<template src="./main.html"></template>

<script>
import ToolBar from "@/components/layout/ToolBar";
import LeftBar from "@/components/layout/LeftBar";

export default {
  name: "MainPage",
  components: {
    ToolBar,
    LeftBar,
  },

  data() {
    return {
      menu: [],
      disabilitaBtn: false,
      drawer: true,
    };
  },

  computed: {
    loading() {
      return this.$store.state.app.loading;
    },
    utente() {
      return this.$store.getters["user/getNome"];
    },
    mail() {
      return this.$store.getters["user/getMail"];
    },
  },

  mounted() {
    this.init();
  },

  methods: {
    async init() {
      try {
        const res = await this.$store.dispatch("user/userInfo");
        this.menu = res.data.menu;
      } catch (error) {
        console.log(error);
      }
    },

    async esci() {
      this.disabilitaBtn = true;
      try {
        await this.$store.dispatch("auth/logout");
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
